import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import { inventoryBySerialNumberFragment } from './graphql'
import type { SetOptional } from 'type-fest'
import type { AddMultipleSerialNumbersArgs, InventoryBySerialNumber } from '@ztechapps/common.contract'

export const addMultipleSerialNumbersQuery = gql`
  mutation addMultipleSerialNumbers($input: AddMultipleSerialNumbersArgs!) {
    addMultipleSerialNumbers(input: $input) {
      ...inventoryBySerialNumberFragment
    }
  }
  ${inventoryBySerialNumberFragment}
`

export function useAddMultipleSerialNumbers(
  { query, ...props } = {} as SetOptional<UseMutationProps, 'query'>
): UseActionResult<InventoryBySerialNumber[], AddMultipleSerialNumbersArgs> {
  query = query ?? addMultipleSerialNumbersQuery

  return useActionMutation({
    query,
    ...props,
  })
}
